import { DownloadFxReportPayload } from '@/pages/FxAnalysis/types';
import { GenericResponse } from '@/types/downloadReports';
import { AxiosInstance, AxiosResponse } from 'axios';

export default class FxAnalysisAPI {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async downloadFxHeatmapReport(
    payload: DownloadFxReportPayload,
  ): Promise<AxiosResponse<GenericResponse>> {
    return this.client.post(
      '/v2/reporting/download-fx-heatmap-report/',
      payload.fx_heatmap,
    );
  }
}
